import { styled } from 'next-yak';

import { Card } from '@xing-com/card';
import { scale390, scale440, spaceXL } from '@xing-com/tokens';

export const CardContainer = styled(Card)`
  flex: 1 0 0;
  height: 580px;
  max-width: ${scale440};
  min-width: ${scale390};
  position: relative;

  & > div:first-child {
    flex: 1;
    gap: ${spaceXL};
  }
`;
